import { useAuthEmployeeQuery } from "modules/auth/hooks/useAuthEmployeeQuery"
import { ReactElement } from "react"
import { BackofficeType, hasBackofficeAccess } from "schema"

type Props = {
  children: ReactElement
  superadminOnly?: boolean
}

export const AdminOnly = ({ children, superadminOnly = false }: Props) => {
  const { data } = useAuthEmployeeQuery()

  if (!data) {
    return null
  }

  if (superadminOnly && data.backofficeType === BackofficeType.Superadmin) {
    return children
  }

  if (!superadminOnly && hasBackofficeAccess(data.backofficeType)) {
    return children
  }

  return null
}
